import { FaWhatsapp } from "react-icons/fa";
import { ButtonWhatsApp } from "./styles";
import { buildWhatsAppLink } from "../../utils/whatsapp";

function FloatingButtonWhatsApp() {
    const whatsappHref = buildWhatsAppLink();

    return (
        <ButtonWhatsApp
            whileInView="visible"
            initial="initial"
            viewport={{ once: true }}
            variants={{
            visible: {
                opacity: 1,
                y: 0,
                transition: { duration: 1, delay: 0.3 },
            },
            }}
        >
            <a href={whatsappHref} rel="noreferrer" target="_blank">
                <FaWhatsapp />
            </a>
        </ButtonWhatsApp>
    )

}

export default FloatingButtonWhatsApp;
